import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import React, {useEffect, useRef, useState} from "react";
import {v4} from "uuid";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {Checkbox, FormControlLabel} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import {ICharWeapon} from "../../_interfaces/ICharWeapon";
import {s_char_weapons} from "../../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import {WeaponsUpdate} from "../../_api/BEWeapons";

interface IProp {
    edit: string,
    isOpen: (id: string) => void
}

function WeaponsEdit({edit, isOpen}: IProp) {
    useSignals()

    const mod_15 = [...Array(16).keys()];

    const descRef = useRef<HTMLInputElement>(null);

    const [weapon, setWeapon] = useState<ICharWeapon | null>(null)

    useEffect(() => {
        const fw = s_char_weapons.value.find(d => d.id === edit);
        if (fw) {
            setWeapon(fw)
        } else setWeapon(null)
    }, [edit])

    const save = () => {
        let weapons = s_char_weapons.value;

        if (weapon) {
            const found = weapons.findIndex(x => x.id === weapon?.id);
            if (found >= 0) {
                weapon.descr = descRef.current?.value as string
                setWeapon(weapon)
                weapons[found] = weapon;
                s_char_weapons.value = weapons;
                WeaponsUpdate(weapon)
            }
        }
        isOpen('')
    }

    const cancel = () => {
        isOpen('')
        setWeapon(null)
    }

    const remove = () => {
        const deleteId = weapon?.id
        if (deleteId) {
            let weapons = s_char_weapons.value;
            const f = weapons.findIndex(x => x.id === deleteId);
            if (f >= 0) {
                weapons.splice(f, 1);
                s_char_weapons.value = weapons;
                // TODO send delete
                isOpen('')
            }
        }
    }

    return <Dialog open={edit !== ''}>
        <DialogContent>
            {weapon?.name && weapon?.type === 'close' ? <div>Nahkampfwaffe</div>:<div>Fernkampfwaffe</div>}
            <div>{weapon?.name}</div>
            <TextField style={{width: '100%', marginTop: 8}}
                       defaultValue={weapon?.descr}
                       label={'Beschreibung'}
                       inputRef={descRef}>
            </TextField>

            <Stack style={{width: '100%', marginTop: 8}} direction={'row'}>
                <FormControlLabel style={{marginLeft: 0}} control={
                    <Checkbox defaultChecked={weapon?.wield || false}
                              onChange={
                                  (e) => {
                                      let curr = weapon;
                                      if (curr) {
                                          curr.wield = e.target.checked;
                                          setWeapon(curr)
                                      }
                                  }
                              }/>
                } label="getragen"/>

                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id="dmg_mod_label">Modifikator Schaden</InputLabel>
                    <Select defaultValue={weapon?.dmg_mod}
                            labelId="dmg_mod_label"
                            style={{width: "100%"}}
                            onChange={(e) => {
                                let curr = weapon;
                                if (curr) {
                                    curr.dmg_mod = e.target.value as number;
                                    setWeapon(curr)
                                }
                            }
                            }
                    >
                        {mod_15.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                    </Select>
                </FormControl>
            </Stack>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => save()}><CheckIcon/></Button>
            <Button onClick={() => cancel()}><ClearIcon/></Button>
            <Button onClick={() => remove()}><DeleteOutlineIcon/></Button>
        </DialogActions>
    </Dialog>

}

export default WeaponsEdit;
